"use client";

import { Suspense, useState } from "react";
import { Header } from "@/components/Header";
import { Sidebar } from "@/components/Sidebar";

export default function DocsLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="flex min-h-screen flex-col bg-transparent dark:bg-transparent">
      <Header floating={false} onMenuClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />
      
      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="fixed inset-0 z-40 bg-black/50 lg:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      <div className="relative flex-1 bg-[#f7f9fc] dark:bg-transparent">
        <div className="mx-auto w-full max-w-[1600px] items-start px-3 md:px-4 lg:grid lg:grid-cols-[240px_minmax(0,1fr)] lg:gap-6 xl:px-6 xl:grid-cols-[290px_minmax(0,1fr)] xl:gap-8 relative">
          <Suspense fallback={null}>
            <Sidebar className={isMobileMenuOpen ? "fixed left-0 top-[4.75rem] z-50 block h-[calc(100vh-4.75rem)] w-[280px] border-r border-white/70 dark:border-white/10 bg-[rgba(248,250,255,0.96)] dark:bg-[#0f172a]/96 px-4 shadow-2xl backdrop-blur-xl lg:hidden" : ""} />
          </Suspense>
          
          {/* Vertical Divider */}
          <div className="hidden lg:block absolute left-[240px] xl:left-[290px] top-[2rem] bottom-12 w-[1px] bg-[#e2e8f0] dark:bg-white/10 ml-[11px] xl:ml-[15px]"></div>
          
          <main className="relative flex-1 min-w-0 py-6 lg:py-8 lg:pl-6 xl:pl-8">
          {children}
          </main>
        </div>
      </div>
    </div>
  );
}
